import type { Calendar } from 'v-customizable-date-picker';

export const gregorianCalendar: Calendar = {
    isSame(first: Date, second: Date): boolean {
        return dayConfig.gregory(first).isSame(second, 'day');
    },
    isAfter(first: Date, second: Date): boolean {
        return dayConfig.gregory(first).isAfter(second, 'day');
    },
    isBetween(date: Date, first: Date, second: Date): boolean {
        return dayConfig.gregory(date).isBetween(first, second, 'day');
    },
    daysInMonth(month: number, year: number): number {
        return dayConfig
            .gregory()
            .year(year)
            .month(month)
            .date(1)
            .daysInMonth();
    },
    firstDayInMonth(month: number, year: number): number {
        return dayConfig.gregory().year(year).date(1).month(month).day();
    },
    getDate(year: number, month: number, dayP: number): Date {
        return dayConfig.gregory().year(year).month(month).date(dayP).toDate();
    },
    getYear(date: Date): number {
        return dayConfig.gregory(date).year();
    },
    getMonth(date: Date): number {
        return dayConfig.gregory(date).month();
    },
    getDayInMonth(date: Date): number {
        return dayConfig.gregory(date).date();
    },
    getDayInWeek(date: Date): number {
        return dayConfig.gregory(date).day();
    },
    startDayWeek: 1,
    weekdays: 'دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه_یک‌شنبه'.split('_'),
    weekdaysMin: 'د_س_چ_پ_ج_ش_ی'.split('_'),
    months: 'ژانویه_فوریه_مارس_آوریل_می_ژوئن_جولای_آگوست_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
        '_'
    ),
    currentYear: dayConfig.gregory().year(),
    currentMonth: dayConfig.gregory().month(),
    currentDay: dayConfig.gregory().date(),
};
export const jalaliCalendar: Calendar = {
    isSame(first: Date, second: Date): boolean {
        return dayConfig.gregory(first).isSame(second, 'day');
    },
    isAfter(first: Date, second: Date): boolean {
        return dayConfig.gregory(first).isAfter(second, 'day');
    },
    isBetween(date: Date, first: Date, second: Date): boolean {
        return dayConfig.gregory(date).isBetween(first, second, 'day');
    },
    daysInMonth(month: number, year: number): number {
        return dayConfig
            .jalali(`${year}-${month + 1}-01`, { jalali: true })
            .daysInMonth();
    },
    firstDayInMonth(month: number, year: number): number {
        return dayConfig
            .jalali(`${year}-${month + 1}-01`, {
                jalali: true,
            })
            .day();
    },
    getDate(year: number, month: number, day: number): Date {
        return dayConfig
            .jalali(`${year}-${month + 1}-${day}`, {
                jalali: true,
            })
            .toDate();
    },
    getYear(date: Date): number {
        return dayConfig.jalali(date).year();
    },
    getMonth(date: Date): number {
        return dayConfig.jalali(date).month();
    },
    getDayInMonth(date: Date): number {
        return dayConfig.jalali(date).date();
    },
    getDayInWeek(date: Date): number {
        return dayConfig.jalali(date).day();
    },
    startDayWeek: 6,
    weekdays: 'شنبه_یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه'.split('_'),
    weekdaysMin: 'ش_ی_د_س_چ_پ_ج'.split('_'),
    months: 'فروردین_اردیبهشت_خرداد_تیر_مرداد_شهریور_مهر_آبان_آذر_دی_بهمن_اسفند'.split(
        '_'
    ),
    currentYear: dayConfig.jalali().year(),
    currentMonth: dayConfig.jalali().month(),
    currentDay: dayConfig.jalali().date(),
};
